import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { SearchableMenuBody, SearchableMenuMultiSelectList, SearchableMenuProvider, SearchableMenuSearchHeader, useSearchableMenuFuse, } from 'shared/domains/common-ui/SearchableMenu';
import { AddPartyItem } from './AddPartyItem';
import { PartiesMenuDocument } from './PartiesMenu.gql';
import { MenuFooter } from '../MenuFooter';
import { NoResults } from '../NoResults';
export function PartiesMenu(props) {
    const { property, initialValue = [], onChange, onClear } = props;
    const { label } = property;
    const [selectedParties, setSelectedParties] = useState(initialValue);
    const { data, loading, error } = useQuery(PartiesMenuDocument);
    const parties = ((data === null || data === void 0 ? void 0 : data.documentMetadataPairsDistinctValuesForProperty) || []);
    const uniqueParties = [...new Set([...parties, ...selectedParties])].reduce((acc, party) => {
        if (typeof party !== 'string') {
            return acc;
        }
        const trimmedValue = party.trim();
        if (trimmedValue === '') {
            return acc;
        }
        return [...acc, trimmedValue];
    }, []);
    const normalizedParties = uniqueParties.map((party) => ({ id: party }));
    const search = useSearchableMenuFuse(normalizedParties, {
        keys: ['id'],
        threshold: 0,
    });
    const selectParty = (party) => {
        setSelectedParties([...selectedParties, party]);
    };
    const unselectParty = (party) => {
        setSelectedParties(selectedParties.filter((p) => p !== party));
    };
    const handleSave = () => {
        if (selectedParties.length === 0) {
            onClear(property);
        }
        else {
            onChange(property, selectedParties);
        }
    };
    const handleClear = () => {
        onClear(property);
    };
    const handleSelectParty = (party) => {
        const isSelected = selectedParties.includes(party.id);
        if (isSelected) {
            unselectParty(party.id);
        }
        else {
            selectParty(party.id);
        }
    };
    if (error) {
        <Menu.ItemNested target={label} loading={loading}>
      <NoResults>
        <Trans comment="Bulk action: Metadata - Parties menu - Error">An error occurred when fetching parties</Trans>
      </NoResults>
    </Menu.ItemNested>;
    }
    return (<Menu.ItemNested target={label} loading={loading}>
      <SearchableMenuProvider {...search}>
        <SearchableMenuSearchHeader />
        <SearchableMenuBody>
          <SearchableMenuMultiSelectList emptyComponent={<AddPartyItem onAddNewParty={handleSelectParty}/>} onSelect={handleSelectParty} renderItem={({ id }) => id} selected={selectedParties}/>
        </SearchableMenuBody>

        <MenuFooter onClear={handleClear} onSave={handleSave}/>
      </SearchableMenuProvider>
    </Menu.ItemNested>);
}
